<template>
  <div>
    <!-- 弹出层 -->
    <div class="modal" :class="isShow?'is-active':''">
      <div class="modal-background"></div>
      <div class="modal-content">
        <video :src="videolink" controls='controls' loop="false" preload="auto" autoplay="autoplay"></video>
      </div>
      <button class="modal-close is-large" @click="close()"></button>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  props: ['isShow', 'videolink'],
  methods: {
    close () {
      this.$emit('closeModal')
    }
  },
  mounted () {
  }
}
</script>
<style>
.modal .modal-content {
  width: 1000px;
}

.modal.is-active {
  z-index: 101;
}

.modal video {
  width: 100%;
  height: 100%;
}
</style>
